export default __webpack_public_path__ + "static/media/copy.6e0e9cf9.svg";